import React from "react";
import { motion } from "framer-motion";
import cx from "classnames";
import { Item, Variant } from "../Types";

/**
 * Item List
 */
interface ListProps {
  items: Item[];
  variant: Variant;
  onItemClicked: (item: Item) => void;
}

const panelVariants = {
  open: {
    transition: { staggerChildren: 0.07, delayChildren: 0.2 }
  },
  closed: {
    transition: { staggerChildren: 0.05, staggerDirection: -1 }
  }
};

export const ItemsList: React.FC<ListProps> = props => (
  <motion.div
    variants={panelVariants}
    initial="closed"
    animate={props.variant}
    className="SiteNavigation__LinksWrapper"
  >
    {props.items.map(item => (
      <ItemRenderer key={item.href} item={item} onClick={props.onItemClicked} />
    ))}
    {props.children}
  </motion.div>
);

/**
 * Item
 */
interface ItemProps {
  item: Item;
  onClick: (item: Item) => void;
}

export const itemVariants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
};

const ItemRenderer: React.FC<ItemProps> = props => (
  <motion.div
    variants={itemVariants}
    onClick={() => props.onClick(props.item)}
    className={cx("SiteNavigation__Link", "SiteNavigation__Link--clickable")}
  >
    {props.item.title}
  </motion.div>
);
